import { useEffect, useState } from "react";

/** Countdown of `seconds` that only starts once `started` becomes true. */
export function useOfferCountdown(seconds: number, started: boolean) {
  const [remaining, setRemaining] = useState(seconds);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(id);
  }, []);

  useEffect(() => {
    if (!started) return;
    const end = Date.now() + seconds * 1000;
    const id = window.setInterval(() => {
      const left = Math.max(0, Math.round((end - Date.now()) / 1000));
      setRemaining(left);
      if (left === 0) window.clearInterval(id);
    }, 250);
    return () => window.clearInterval(id);
  }, [started, seconds]);

  const pad = (n: number) => String(n).padStart(2, "0");
  const min = Math.floor(remaining / 60);
  const sec = remaining % 60;

  return {
    minutes: pad(min),
    seconds: pad(sec),
    minutesNum: min,
    secondsNum: sec,
    expired: remaining === 0,
    time: `${pad(now.getHours())}:${pad(now.getMinutes())}`,
  };
}
